import { createContext } from "react"

/**
 * Context that provides access to AEM page content.
 * @type {React.Context<{aemPageContent: object}>}
 */
export const AEMPageContentContext = createContext({
  aemPageContent: {},
})
